import React from 'react';
import styled, { css } from 'styled-components';
import Modal from '../../common/molecules/Modal';
import SearchWrapper from '../../context/Search';
import HorizontalSearchBar from '../../molecules/HorizontalSearchBar';
import HorizontalSearchResults from '../../molecules/HorizontalSearchResults';
import VerticalSearchBar from '../../molecules/VerticalSearchBar';
import VerticalSearchResults from '../../molecules/VerticalSearchResults';
import useSearchModalLogic from './useSearchModalLogic';

// DEPRECATED

const maxWidth = css`
  margin: 0 auto;
  max-width: 1200px;
`;

const StyledHorizontalSearchBar = styled(HorizontalSearchBar)`
  ${maxWidth}
  margin-top: ${props => props.theme.margin.large};
  padding: ${props =>
    `${props.theme.padding.large} ${props.theme.padding.large}`} ;
`;

const StyledDesktopSearchResultsContainer = styled.div`
  background-color: ${props => props.theme.background.normal};
`;

const StyledHorizontalSearchResults = styled(HorizontalSearchResults)`
  ${maxWidth}
  padding: ${props =>
    `${props.theme.padding.large} ${props.theme.padding.xlarge}`} ;
`;

const StyledMobileModal = styled(Modal)`
  margin-top: ${props => props.theme.margin.small};
  padding: ${props =>
    `${props.theme.padding.large} ${props.theme.padding.medium}`};
`;

const SearchModalConsumer = () => {
  const { mobile, showModal } = useSearchModalLogic();

  const handleSearchButtonClick = () => {};

  if (!showModal) return <></>;
  return (
    <>
      {mobile ? (
        <StyledMobileModal>
          <VerticalSearchBar />
          <VerticalSearchResults />
        </StyledMobileModal>
      ) : (
        <Modal>
          <StyledHorizontalSearchBar onSearch={handleSearchButtonClick} />
          <StyledDesktopSearchResultsContainer>
            <StyledHorizontalSearchResults />
          </StyledDesktopSearchResultsContainer>
        </Modal>
      )}
    </>
  );
};

const SearchModal = () => {
  return (
    <SearchWrapper>
      <SearchModalConsumer />
    </SearchWrapper>
  );
};

export default SearchModal;
